module.exports = __webpack_public_path__ + "img/faq.82c77fa0.svg";